import { cn } from '@/utils/classUtils';
import { type ButtonHTMLAttributes, type FC } from 'react';

const BASE =
  'inline-flex items-center gap-1.5 font-medium text-white bg-[length:200%_100%] animate-shimmer bg-gradient-to-r from-blue-500 via-blue-400 to-blue-500 hover:brightness-110 transition-all rounded-md';

const SIZE = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
} as const;

interface UpgradeButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: keyof typeof SIZE;
}

export const UpgradeButton: FC<UpgradeButtonProps> = ({
  size = 'sm',
  className,
  children,
  ...props
}) => (
  <button type="button" className={cn(BASE, SIZE[size], className)} {...props}>
    {children}
  </button>
);
